import { Action } from '../../shared/models/action.model';
import { updateAction } from '../../utils/utility';
import actionTypes from '../types/grievanceTypes';

export const getGrievanceList = (onSuccess: any): Action<any> =>
  updateAction(actionTypes.GET_GRIEVANCE_LIST, onSuccess);

export const getGrievanceListSuccess = (response: any): Action<any> =>
  updateAction(actionTypes.GET_GRIEVANCE_LIST_SUCCESS, { response });

export const setIsShowReply = (isShowReply: boolean): Action<boolean> => ({
  type: actionTypes.SET_IS_SHOW_REPLY, ...{ isShowReply },
});
export const setIsShowChatThread = (isShowChatThread: boolean): Action<boolean> => ({
  type: actionTypes.SET_IS_SHOW_CHAT_THREAD, ...{ isShowChatThread },
});
export const saveGrievanceResponse = (formData: any, onSuccess: any = (): any => { }, onError: any = (): any => { }): Action<any> => (
  updateAction(actionTypes.SAVE_GRIEVANCE_RESPONSE, { formData, onSuccess, onError })
);

export const fetchDetailedGrievance = (id: any, onSuccess: any, onError: any): Action<any> =>
  updateAction(actionTypes.FETCH_DETAILED_GRIEVANCE, { id, onSuccess, onError });

export const fetchClaimList = (payload: any): Action<any> => {
  return updateAction(actionTypes.FETCH_CLAIM_LIST, payload);
};

export const fetchGrievanceList = (payload: any): Action<any> => {
  return updateAction(actionTypes.FETCH_GRIEVANCE_LIST, payload);
};

export const submitGrievanceReply = (data: any, onSuccess: any, onError: any): Action<any> =>
  updateAction(actionTypes.SUBMIT_GRIEVANCE_REPLY, { data, onSuccess, onError });

export const searchClaimList = (): Action<any> => {
  return updateAction(actionTypes.SEARCH_CLAIM_LIST);
};
export const setPageIndexList = (payload: any): Action<any> => {
  return updateAction(actionTypes.SET_PAGE_INDEX_LIST, payload);
};

export const setSelectedClaims = (selectedClaims: any): Action<any> =>
  updateAction(actionTypes.SET_SELECTED_CLAIMS, selectedClaims);

export const raiseNewGrievance = (formData: any, onSuccess: any, onError: any): Action<any> =>
  updateAction(actionTypes.RAISE_NEW_GRIEVANCE, { formData, onSuccess, onError });

export const raiseOrUpdateGrievance = (grievanceDetails: any, onSuccess: any, onError: any): Action<any> =>
  updateAction(actionTypes.RAISE_OR_UPDATE_GRIEVANCE, { grievanceDetails, onSuccess, onError });

export const replyGrievance = (replyGrievanceData: any, onSuccess: any, onError: any): Action<any> =>
  updateAction(actionTypes.REPLY_GRIEVANCE, { replyGrievanceData, onSuccess, onError });

export const resetGrievance = (): Action<void> =>
  updateAction(actionTypes.RESET_GRIEVANCE);

export const closeTicket = (ticketId: any, onSuccess: any, onError: any): Action<any> =>
  updateAction(actionTypes.CLOSE_TICKET, { ticketId, onSuccess, onError });
